import Button from "../button";

export default function FindDoctorCard({customClass = '',  doctor }) {
  const {
    first_name,
    last_name,
    primary_specialty,
    secondary_specialty,
    mdm_address_line1,
    mdm_address_line2,
    mdm_city,
    mdm_state,
    mdm_zip,
    phone_number,
    ccc_coe,
    research_publications,
    clinical_trials,
    distance
  } = doctor;
  const formatPhoneNumber = (phone) => {
    const cleaned = phone?.replace(/\D/g, '');
    const match = cleaned?.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
  };

  return (
    <div className={`find-doctor-tool__card ${customClass}`.trim()}>
      <div className="find-doctor-tool__card-doctor">
        <p className="find-doctor-tool__card-name">{first_name} {last_name}</p>
        <div className="find-doctor-tool__card-specialty">
          <p>{primary_specialty}</p>
          {secondary_specialty && <p>{secondary_specialty}</p>}
        </div>
        <div className="find-doctor-tool__card-address">
          <p>{mdm_address_line1}</p>
          {mdm_address_line2 && <p>{mdm_address_line2}</p>}
          <p>{mdm_city}{mdm_city && ','} {mdm_state} {mdm_zip}</p>
        </div>
      </div>
      <div className="find-doctor-tool__card-info">
        <div className="find-doctor-tool__card-info-col">
          <p className="find-doctor-tool__card-distance">{distance?.toFixed(2)} {distance && <span>mile{distance === 1 ? '' : 's'} away</span>}</p>
          <p className="find-doctor-tool__card-phone">{phone_number && <Button variant={['solid', 'solid--lilac']} href={`tel:${phone_number}`}>{formatPhoneNumber(phone_number)}</Button>}</p>
        </div>
        <div className="find-doctor-tool__card-info-col find-doctor-tool__card-info-filter-options">
          <p className={research_publications === 'TRUE' ? 'has-option' : undefined }><span>Publications</span></p>
          <p className={clinical_trials === 'TRUE' ? 'has-option' : undefined }><span>Clinical trials</span></p>
          <p className={ccc_coe === 'TRUE' ? 'has-option' : undefined }><span>Comp. practice</span></p>
        </div>
      </div>
    </div>
  );
}